// import { encryptStorage } from '@/utils/storage';
import axios from 'axios';
import { apiClientPbx } from '@/api/sipmovil_auth_api.js'
import { apiClient, apiOfficialClient } from './config';

export default {
  getMessages(chatId, page) {
    return apiClient.get(`messages/?contact_msg=${chatId}&page=${page}`);
  },
  getSipmovilMessages(chatId, page, options = {}) {
    return apiClientPbx.get(
      `api/chat/${chatId}/messages/?page_size=${20}&page=${page}`, options
    );
  },
  getMessagesFrom(chatId, messageId, page) {
    return apiClientPbx.get(
      `api/chat/${chatId}/messages/from/${messageId}/?page_size=${20}&page=${page}`
    );
  },
  getFilteredMessages(chat) {
    return apiClientPbx.get(
      `api/chat/get-filtered-messages/?chatId=${chat.chatId}&messageId=${chat.message[0]}`
    );
  },
  saveMessage(message) {
    return apiClient.post(`new_message/`, message);
  },
  uploadFiles(files, token) {
    const formData = new FormData();
    for (let i = 0; i < files.length; i++) {
      const { file } = files[i];
      formData.append(`files[${i}]`, file);
    }
    apiOfficialClient.interceptors.request.use((config) => {
      config.headers = {
        Authorization: `Token ${token}`,
        'Content-Type': 'multipart/form-data',
      };
      return config;
    });
    return apiOfficialClient.post(`upload_files/`, formData);
  },
  uploadSipmovilFiles(file, host, token, data) {
    console.log("uploadSipmovilFiles", file);
    let type = 'file';
    if (file.type.startsWith('image/')) {
      type = 'Imagen';
    } else if (file.type.startsWith('audio/')) {
      type = '.mp3';
    } else if (file.type.startsWith('video/')) {
      type = 'video';
    }
    const dotIndex = file.name.lastIndexOf('.');
    const baseName = dotIndex !== -1 ? file.name.slice(0, dotIndex) : file.name;
    const ext = dotIndex !== -1 ? file.name.slice(dotIndex) : '';
    const hash = Math.random().toString(36).substr(2, 9);
    const uniqueName = `${baseName}_${hash}${ext}`;
    const renamedFile = new File([file], uniqueName, { type: file.type });
    const formData = new FormData();
    formData.append(`attached`, renamedFile);
    formData.append('replyMsj', "false");
    formData.append('typeFile', type);
    formData.append('idUserSend', data.id);
    formData.append('author', data.username);
    formData.append('chat_id', data.chat_id);
    formData.append('durationAudio', 0);
    formData.append('caption', data.caption || '');
    const apiPbxClient = axios.create({
      baseURL: `https://${host}`,
      withCredentials: false,
    });

    apiPbxClient.interceptors.request.use((config) => {
      config.headers = {
        Authorization: "token " + token,
      };
      // console.log("Config from interceptor: ", config);
      return config;
    });
    return apiPbxClient.post('/attached', formData);
  },
  getAvalaibleAgents(token) {
    apiClient.interceptors.request.use((config) => {
      config.headers = {
        Authorization: `Token ${token}`,
      };
      return config;
    });
    return apiClient.get(`agents/`);
  },
  getStatusAgents(token) {
    apiClient.interceptors.request.use((config) => {
      config.headers = {
        Authorization: `Token ${token}`,
      };
      return config;
    });
    return apiClient.get(`status-agents/`);
  },
  sendSipmovilMessage(data) {
    return apiClientPbx.post(`api/chat/send_message/`, data);
  },
  forwardSipmovilMessage(data) {
    return apiClientPbx.post(`api/chat/forward_message/`, data);
  },
  editSipmovilMessage(data) {
    return apiClientPbx.post(`api/chat/edit_message/`, data);
  },
  deleteSipmovilMessage(data) {
    return apiClientPbx.post(`api/chat/delete_message/`, data);
  },
  readSipmovilMessage(data) {
    return apiClientPbx.post(`api/chat/messages_as_read/`, data);
  },
  // task_reacciones: registrar reacción de emoji sobre un mensaje. Endpoint PROPUESTO
  // (por confirmar con backend); alineado al patrón de edit/delete_message. Se deja
  // definido para que reactToMessageAction solo tenga que descomentar su uso.
  reactSipmovilMessage(data) {
    return apiClientPbx.post(`api/chat/react_message/`, data);
  },
  getChatData(chatId) {
    return apiClientPbx.get(`api/chat/chat_data/?chat_id=${chatId}`);
  },
  // recuperar los mensajes de un sender, cuando se usa a api
  // oficial de gupchup
  getSenderMessages(chatId, page, token, options = {}) {
    apiOfficialClient.interceptors.request.use((config) => {
      config.headers = {
        Authorization: `Token ${token}`,
      };
      return config;
    });
    return apiOfficialClient.get(`messages/?sender=${chatId}&page=${page}`, options);
  },
  getSenderMessage(context, token) {
    apiOfficialClient.interceptors.request.use((config) => {
      config.headers = {
        Authorization: `Token ${token}`,
      };
      return config;
    });
    return apiOfficialClient.get(`context_message/${context}/`);
  },
  // enviar un mensaje, cuando se usa a api oficial de gupchup
  // Header directo en la request (no interceptor, para no acumularlos en cada envío).
  saveOfficialMessage(message, token) {
    return apiOfficialClient.post(`new_message/`, message, {
      headers: { Authorization: `Token ${token}` },
    });
  },
  saveOfficialMessagePbx(message, token) {
    return apiOfficialClient.post(`new-template-message/`, message, {
      headers: { Authorization: `Token ${token}` },
    });
  },
  saveSurveyMessage(message, token) {
    apiOfficialClient.interceptors.request.use((config) => {
      config.headers = {
        Authorization: `Token ${token}`,
      };
      return config;
    });
    return apiOfficialClient.post(`new_message_survey/`, message);
  },
};
